import React from 'react';
import { awardeesList } from '../components/awards/AwardeeData';
import AwardeeGridCard from '../components/awards/AwardeeGridCard';

const AwardsPage = () => {
  return (
    <section className="bg-bg-light px-6 py-14 md:px-12">
      <div className="mx-auto max-w-6xl">
        <h1 className="mb-8 text-center text-3xl font-bold text-accent md:text-4xl">
          OUR AWARDEES
        </h1>
        <p className="mx-auto mb-10 max-w-2xl text-center text-base leading-relaxed text-gray-600 md:text-lg">
          Meet the courageous women honored with the DRISHTIKON HIMMATWAALI
          MISSION AWARD. Click on any awardee to read her inspiring story.
        </p>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {awardeesList.map((awardee) => (
            <AwardeeGridCard key={awardee.id} awardee={awardee} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AwardsPage;
